export default __webpack_public_path__ + "static/media/no-expensepolicy.0e3c823f.svg";